module.exports = __webpack_public_path__ + "img/checked-checkbox.c6ee4610.svg";